export default __webpack_public_path__ + "static/alkosto-a4b31d7d81d06058b739ee8ca4efcc80.svg";